<template>
	<section class="section ht-profile-user-transfer">
		<div class="columns is-centered">
			<div class="column is-7-widescreen is-6-fullhd">
				<div v-if="$route.params.type == 'simplepay'" class="container">
					<h2 class="title">{{ t$('Transaction successful') }}</h2>
					<p>{{ $t('Thank you for your purchase.') }}"</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('close') }}</b-button>
				</div>
				<div v-if="$route.params.type == 'cash'" class="container">
					<h2 class="title">{{ $t('Thank you') }}</h2>
					<h2>
						{{ $t('To collect your order, please arrange an appointment with us.') }}
					</h2>
					<span class="label">{{ $t('Order total') }}: {{ $route.query.price | fmtCurrency('HUF') }}</span>
				</div>
				<div v-if="$route.params.type == 'transfer'" class="container">
					<h2 class="title">{{ $t('Transfer') }}</h2>
					<p>{{ $t("You've chosen to pay with transfer.") }}</p>
					<p>
						{{ $t('Please transfer the Order Total to the following bank account:') }}
					</p>
					<table class="table">
						<tbody>
							<tr>
								<td>
									<span class="label">{{ $t('Company') }}</span>
								</td>
								<!-- <td>Szász György</td> -->
								<!-- <td>IQ Store Kft</td> -->
								<td>Szász György<br/>
									HT Auction</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Address') }}</span>
								</td>
								<td>H-1054 Budapest, Akadémia u.6.</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Account number (IBAN)') }}</span>
								</td>
								<td>
									<!-- HU97 1210 0011 1781 6151 0000 0000 -->
									<!-- HU26 1040 2166 5052 6678 8851 1000 -->
									<!-- HU57 1210 0011 1781 6106 0000 0000 -->
									HU16 1201 1265 0078-5972 0070 0009
								</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Account number (GIRO)') }}</span>
								</td>
								<td>
								<!-- 12100011-17816151 -->
								<!-- 10402166-50526678-88511000 -->
								<!-- 12100011-17816106 -->
									12011265-00785972-00700009
								</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('SWIFT code') }}</span>
								</td>
								<td>
									<!-- GNBAHUHB -->
									<!-- OKHBHUHB -->
									UBRTHUHB
								</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Bank name') }}</span>
								</td>
								<td>
								<!-- K&amp;H Bank Zrt. -->
								<!-- GRÁNIT BANK -->
								Raiffeisen Bank
								</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Bank country') }}</span>
								</td>
								<td>{{ $t('Hungary') }}</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Reference') }}</span>
								</td>
								<td>{{ $route.query.order_id }}</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Amount') }}</span>
								</td>
								<td>{{ $route.query.price | fmtCurrency('HUF') }}</td>
							</tr>
						</tbody>
					</table>
					<!-- <b-button @click="$router.push('/profile/mybids')" type="is-default">Vissza</b-button> -->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
		}
	},
	props: {},
	mounted() {
		console.log('ROUTER', this.$route.params.order_id)
	},
	methods: {
		closeWindow() {
			window.close()
		},
	},
	watch: {},
}
</script>
<style lang="css">
.ht-profile-user-pay-type {
	height: 50vh;
	padding-top: 40px;
	text-align: center;
}
.pay-success {
	color: green;
}
.pay-failed {
	color: red;
}
</style>
